<template>
  <div>

    <div v-if="day.price > 0">
      <div v-if="day.offer > 0">
        <span class="reservation-price-without-offer">{{ formatNumber(day.price) }}</span>
        <span class="reservation-price">{{ formatNumber(day.price - day.offer) }}</span>
      </div>
      <div  v-else>
        <span class="reservation-price">{{ formatNumber(day.price) }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ReservationDayPrice",
  props: {
    day: {}
  },
  methods: {
    formatNumber,
    dateConverter,
  }
}
</script>


<style scoped>
.reservation-price{
  font-size: 9px;
  display: block;
  font-weight: bold
}

.reservation-price-without-offer{
  font-weight: bold;
  font-variation-settings: "wght" 700;
  font-size: 7px;
  text-decoration: line-through;
  color: rgb(165, 165, 165);
  display: block;
}

</style>